import React, { createContext, useState, useContext, useEffect } from 'react';
import { translations } from '../utils/translations';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  // Sayfa yenilendiğinde seçili dili unutmaması için localStorage kullanıyoruz kanka
  const [lang, setLang] = useState(localStorage.getItem('appLang') || 'TR');

  useEffect(() => {
    localStorage.setItem('appLang', lang);

    // KANKA: İŞTE ÇÖZÜM BURASI!
    // Sayfa yönünü (dir) ARAPÇA olsa bile 'ltr' (soldan sağa) olarak sabitliyoruz.
    // Böylece mizanpaj ters dönmez, görseldeki o karmaşa yaşanmaz.
    document.documentElement.dir = 'ltr'; 
    
    // SEO ve tarayıcı uyumluluğu için sadece dil kodunu güncelliyoruz
    document.documentElement.lang = lang.toLowerCase();
  }, [lang]);

  // t fonksiyonu: Verilen yolu (path) bulup ilgili dildeki metni döner
  const t = (path) => {
    const keys = path.split('.');
    let result = translations[lang];

    keys.forEach(key => {
      if (result) result = result[key];
    });

    return result || path; 
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

// Componentlerin kolayca ulaşması için custom hook
export const useLanguage = () => useContext(LanguageContext);